import React, { useState } from 'react';
import PropTypes from 'prop-types';

import './HelpMeChoose.css';

import { HelpMeChooseCategories } from 'src/Common/constants';

import HelpMeChoosePlan from 'src/Components/HelpMeChoosePlan/HelpMeChoosePlan';

import { getRecommendedOffers } from 'src/Services/Services';
import { HMCIcon } from 'src/Components/Common';
import { isMobileView } from 'src/Utility/utility';

const HelpMeChoose = (props) => {

  const [helpmeChoosePlanVisible, setHelpmeChoosePlanVisible] = useState(false);
  const [defaultOptions, setDefaultOptions] = useState(HelpMeChooseCategories);

  let recommendedOptions = []

  getRecommendedOffers()
    .then((res) => {
      recommendedOptions = res;
    })
    .catch((error) => console.log(error));

  const getInternetUsageOptions = (response) => {

    const ret = {};
  
    for (const option of defaultOptions) {
  
      for (const item of response) {
  
        if (typeof option.enterpriseType === 'string'
          && typeof item.enterpriseType === 'string'
          && item.enterpriseType.toLowerCase().includes(option.enterpriseType.toLowerCase())
        ) {
    
          ret[option.title] = option;
        }
      }
    }
    
    return Object.entries(ret).map(([_, item]) => item);
  };

  return (
    <div className="help-me-choose-main-wrapper" automationid="SalesLead_Div_HelpMeChooseMainWrapper_0">
      <div className="help-me-choose-btn-black" automationid="SalesLead_Div_HelpMeChooseButtonDiv_1">
        <button automationid="SalesLead_Button_HelpMeChooseButton_2"
          onClick={() => {
            setHelpmeChoosePlanVisible(true)
            setDefaultOptions(getInternetUsageOptions(recommendedOptions))
          }} >
          {
            !isMobileView() &&
              <div className='help-me-choose-btn-icon'>
                <HMCIcon />
              </div>
          }
          Help me choose
        </button>
      </div>
      { helpmeChoosePlanVisible
        ? <HelpMeChoosePlan
          determinePackages={props.determinePackages}
          close={() => setHelpmeChoosePlanVisible(false)}
          defaultOptions={defaultOptions}/>
        : null
      }
    </div>
  );
}

HelpMeChoose.propTypes = {
  determinePackages: PropTypes.func.isRequired
}

export default HelpMeChoose;